import lightBackgrounImage from 'images/computer-girl.png';
import darkBackgrounImage from 'images/computer-girl-dark.png';

const themes = {
  light: {
    themeId: 'light',
    backgroundImage: lightBackgrounImage,
    stepsBgColor: '#FFFFFF',
    stepsTextColor: 'rgba(0,0,0,0.6)',
    stepsShadow: '0 1px 3px 0 rgba(0,0,0,0.08), 0 4px 6px 0 rgba(50,50,93,0.11)',
    stepCircleBgColor: 'rgba(0,0,0,0.1)',
    stepCircleNumberColor: 'rgba(0,0,0,0.4)',
    stepTitleColor: 'rgba(0,0,0,0.7)',
    stepTitleTodoColor: 'rgba(0,0,0,0.4)',
    stepVerticalLineColor: '#D9D9DE',
  },
  dark: {
    themeId: 'dark',
    backgroundImage: darkBackgrounImage,
    stepsBgColor: '#263142',
    stepsTextColor: 'rgba(255,255,255,0.6)',
    stepsShadow: '0 1px 3px 0 rgba(0,0,0,0.08), 0 4px 6px 0 rgba(0,0,0,0.12)',
    stepCircleBgColor: 'rgba(255,255,255,0.1)',
    stepCircleNumberColor: 'rgba(255,255,255,0.6)',
    stepTitleColor: 'rgba(255,255,255,0.7)',
    stepTitleTodoColor: 'rgba(255,255,255,0.4)',
    stepVerticalLineColor: 'rgba(255,255,255,0.1)',
  },
};

export default themes;
